export default {
  setCurrentSeason(context) {
    const season = context.getters.seasonsList.filter((season) => {
      return season.isActive;
    });

    if (season.length === 0) {
      console.log(
        "setCurrentSeason(): no active season, clearing active season"
      );
      context.commit("CLEAR_CURRENT_SEASON");
    } else if (season.length > 1) {
      console.log(
        "setCurrentSeason(): ' + season.length + ' active seasons, clearing active season"
      );
      context.commit("CLEAR_CURRENT_SEASON");
    } else {
      context.commit("SET_CURRENT_SEASON", season[0]);
    }

    console.log("setCurrentSeason: currentSeason.seasonId = ", context.getters.currentSeason.seasonId);
  },
  loadSeason(context, season) {
    context.commit("LOAD_SEASON", season);
  },
  async loadSeasons(context) {
    console.group("loadSeasons");
    const response = await fetch(
      `https://ironman-2021-7de88-default-rtdb.firebaseio.com/seasons.json`
    );

    const responseData = await response.json();
    console.info("responseData = ", responseData);

    if (!response.ok) {
      const error = new Error(
        responseData.message || "Failed to fetch seasons."
      );
      throw error;
    }

    // successfully retrieved seasons, clear the current ones
    context.dispatch("clearSeasons");

    if (responseData !== null) {
      for (const key in responseData) {
        const season = {
          seasonId: key,
          year: responseData[key].year,
          isActive: responseData[key].isActive,
          conferences: responseData[key].conferences,
          divisions: responseData[key].divisions,
          teamsPerDivision: responseData[key].teamsPerDivision,
          seasonGamesPerTeam: responseData[key].seasonGamesPerTeam,
          regularSeasonWeeks: responseData[key].regularSeasonWeeks,
          seasonStartDate: new Date(responseData[key].seasonStartDate),
          seasonEndDate: responseData[key].seasonEndDate,
          tournamentStartDate: new Date(responseData[key].tournamentStartDate),
          tournamentPickingOpen: responseData[key].tournamentPickingOpen,
        };

        console.info("responseData");
        console.table(responseData);
        console.info("key = ", key, " season = ", season);
        context.dispatch("loadSeason", season);
      }
    }

    console.info("seasonsList");
    console.table(context.getters.seasonsList);

    context.dispatch("setCurrentSeason");
    console.info("currentSeason: ", context.getters.currentSeason);

    console.groupEnd();
  },
  clearSeasons(context) {
    context.commit("CLEAR_ALL_SEASONS");
  },
  async createSeason(context, season) {
    const token = context.rootGetters.token;
    let message = null;

    // adding season, it shouldn't have an Id
    if (season.seasonId !== null) {
      message = "Unable to add Season, seasonId already exists (" + season.seasonId + ")";
    } else {
      console.log("saveSeason: storing season: ", season);
    }

    if (message !== null) {
      const error = new Error(message);
      throw error;
    }

    const response = await fetch(
      `https://ironman-2021-7de88-default-rtdb.firebaseio.com/seasons.json?auth=` + token,
      {
        method: "POST",
        body: JSON.stringify({
          year: season.year,
          isActive: season.isActive,
          conferences: season.conferences,
          divisions: season.divisions,
          teamsPerDivision: season.teamsPerDivision,
          seasonGamesPerTeam: season.seasonGamesPerTeam,
          regularSeasonWeeks: season.regularSeasonWeeks,
          seasonStartDate: season.seasonStartDate,
          seasonEndDate: season.seasonEndDate,
          tournamentStartDate: season.tournamentStartDate,
          tournamentPickingOpen: season.tournamentPickingOpen,
        }),
      }
    );

    const responseData = await response.json();

    if (!response.ok) {
      const error = new Error(responseData.message || "Failed to save season.");
      throw error;
    }

    season.seasonId = responseData.name;
    console.log("createSeason: responseData = ", responseData);
    console.log("createSeason: new seasonId = ", season.seasonId);
    context.dispatch("saveSeason", season); // save it with the new seasonId
    context.dispatch("loadSeason", season); // add it to the seasonsList
  },
  async saveSeason(context, season) {
    const token = context.rootGetters.token;
    let message = null;

    if (!season.seasonId || season.seasonId === "") {
      message = "Unable to save Season, no Season selected.";
    } else {
      console.log("saveSeason: storing season: ", season.seasonId);
    }

    if (message !== null) {
      const error = new Error(message);
      throw error;
    }

    console.log("saveSeason: season = ",  season);

    const response = await fetch(
      `https://ironman-2021-7de88-default-rtdb.firebaseio.com/seasons/${season.seasonId}.json?auth=` + token,
      {
        method: "PUT",
        body: JSON.stringify(season),
      }
    );

    const responseData = await response.json();

    if (!response.ok) {
      const error = new Error(responseData.message || "Failed to save season.");
      throw error;
    }
  },
};
